import React from "react";

import { WmsLayer } from "../../layers/WmsLayer";
import { TreeCoverLayer } from "../../layers/TreeCoverLayer";
import AsbestosLayerGroup from "./AsbestosLayerGroup";
import AsbestosDashboard from "./Components/AsbestosDashboard";

class AsbestosDashboardLayerGroup extends AsbestosLayerGroup {
  constructor(map = null, layer_group_data) {
    super(map, layer_group_data);

    this.has_dashboard = true;
    this.dashboard = ({ lang }) => <AsbestosDashboard lang={lang} layer_group_uuid={layer_group_data.uuid}/>;

    // this.layers = this.createLayers();
  }

//   createLayers = () => {
//     const TYPE_MAP = {
//       BIODIVERSITY_TREES: TreeCoverLayer,
//     };
//     const layers_to_add = [];

//     for (const layer_data of this.layer_list_data) {
//       const { layer_type } = layer_data;

//       const layerClass = TYPE_MAP[layer_type] || WmsLayer;
//       const new_layer = new layerClass(layer_data, this.id, this.map);

//       layers_to_add.push(new_layer);
//     }
//     return layers_to_add;
//   };
}

export default AsbestosDashboardLayerGroup;
